// Small helper to open the global inquiry popup from anywhere.
export function openInquiryPopup() {
  try { window.dispatchEvent(new CustomEvent('open-inquiry-popup')); } catch (_) { /* ignore */ }
}

// Common WhatsApp / phone / mail hrefs for the site.
export const CONTACT = {
  phone: '+919509406802',
  phoneDisplay: '+91 95094 06802',
  whatsapp: 'https://wa.me/919509406802',
  whatsappCounsel: 'https://wa.me/919509406802?text=Hi%2C%20I%20want%20free%20counselling%20for%20MBBS%20in%20Russia.',
  email: 'info@russianeducation.in',
};
